import apiClient from './api-client'

const getOrder = ({ hash }) =>
  apiClient.get(`/orders/get_by_hash/${hash}`, {
  })

export default {
  getOrder,
}



// WEBPACK FOOTER //
// ./src/lib/Api.js